import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { AuthService } from '../../../services/auth/auth.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dashboard-signout',
  standalone: true,
  imports: [CommonModule, ConfirmDialogModule, ButtonModule],
  providers: [ConfirmationService],
  templateUrl: './user-signout.component.html',
})
export class UserSignoutComponent {

  // When true, removes top margins for mobile header alignment
  isMobile = input<boolean>(false);

  lougoutService = inject(AuthService);
  router = inject(Router);
  confirmationService = inject(ConfirmationService);

  redirectToProfilePage() {
     this.router.navigate(['/mbrs/profile']);
  }

  confirmLogout() {
    this.confirmationService.confirm({
      accept: () => this.logout(),
      reject: () => {},
    });
  }

  logout() {
    this.lougoutService.logout()
    .pipe(
      tap({
        next: (response) => {
          this.router.navigate(['/auth/login']);
          // if (response.status) {
          //   this.router.navigate(['/auth/login']);
          // } else {
          //   console.error('Logout failed:', response.errors);
          // }
        },
        error: (error) => {
          this.router.navigate(['/auth/login']);
          // console.error('Logout error:', error);
        },
      }))
      .subscribe();
  }
  
}
